import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AdminMemberTip } from "@/components/admin/AdminMemberTip";
import { MemberInsights } from "@/components/admin/MemberInsights";
import { MemberRow } from "@/components/admin/MemberRow";

export function AdminMembers() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/memberships").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const sync = async (m) => {
    try { const r = await api.post(`/admin/memberships/${m.membership_id}/sync`); toast.success(`Synced — ${r.data.status}`); load(); }
    catch { toast.error("Sync failed"); }
  };
  if (items === null) return <div className="text-slate-500 text-sm">Loading members…</div>;
  const live = items.filter((m) => m.live);
  const mrr = live.reduce((s, m) => s + Number(m.price_usd || 0), 0);
  return (
    <div className="space-y-4" data-testid="admin-members">
      <MemberInsights onNudged={load} />
      <div className="flex flex-wrap items-center gap-3">
        <div className="dg-eyebrow flex items-center gap-1"><ShieldCheck className="w-3 h-3" /> {live.length} active member{live.length === 1 ? "" : "s"} · ${mrr.toFixed(2)}/month</div>
        <span className="text-xs text-slate-500">Stripe bills members monthly. Statuses refresh from Stripe daily and whenever a member opens their page — or tap Sync.</span>
      </div>
      {items.length === 0 && <div className="text-slate-500 text-sm">No members yet. Customers join at /membership.</div>}
      <div className="grid gap-3 md:grid-cols-2">
        {items.map((m) => <MemberRow key={m.membership_id} m={m} onSync={sync} />)}
      </div>
      <AdminMemberTip />
    </div>
  );
}
